import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// features
import { getBranchConfigsByNamesSuccess } from '../branch/actions';
// feature new-do
import { calculateEtaSuccess as calculateLiteCreateDOEtaSuccess } from '../new-do/actions';
import {
  isPageCreateDO,
  getPrimaryReference,
  isSourceTypeEdiOrManual,
  createCustomerLoadNumber,
  getStopPointsLatLonStringsArray,
  mapRateInitChargesWithFuelIndexInfo,
} from '../new-do/helpers';
import {
  PAGE_TYPE_CREATE_DO,
  TAB_NAME_CLO_SUMMARY,
  PAGE_TYPE_CLO_TEMPLATE,
} from '../new-do/constants';
import {
  getNewItemFields,
  getDefaultDropFields,
  getNewContainerFields,
  getDefaultPickupFields,
} from '../new-do/settings/fields-settings';
import {
  calculateEtaSuccess,
  mapRecognizeStopsData,
  getRateFromRecognizeData,
  getBillToFromRecognizeData,
} from '../new-do/reducer';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature lite-new-do
import * as A from './actions';
import { isValidBillToCustomerRateForm } from './validation';
import { defaultBillToFields, allCustomerFormFields, referenceFormInitData } from './settings';
//////////////////////////////////////////////////

// TODO: refactor with new-do common helpers

const staticData = {
  branchList: [],
  fromPage: null,
  loadGuid: null,
  hotOrder: false,
  orderType: null,
  leftActiveTab: 1,
  branchRefTypes: {},
  divisionPrefix: '',
  divisionGuid: null,
  branchConfigs: null,
  telDriverRate: null,
  ignoreWarnings: false,
  saveAndDuplicateQty: 0,
  validationErrors: null,
  customerLoadNumber: '',
  routeTemplateGuid: null,
  primaryRefSequence: null,
  validationWarnings: null,
  sharedAccessorialsList: [],
  loadType: GC.LOAD_TYPE_CLO,
  pageType: PAGE_TYPE_CREATE_DO,
  branchInfo: GC.EMPTY_OPTION_OBJECT,
  rightActiveTab: TAB_NAME_CLO_SUMMARY,
  primaryReference: GC.EMPTY_OPTION_OBJECT,
  referenceFormData: referenceFormInitData,
  // For Containers
  useContainers: false,
  branchDefaultItem: null,
  addedNewFirstDrop: false,
  addedNewFirstPickup: false,
  autoCreateContainerItem: false,
};

const createDOData = {
  rateBackup: null,
  [GC.FIELD_RATE]: null,
  ratePreviewFiles: null,
  pageType: PAGE_TYPE_CREATE_DO,
  [GC.FIELD_LOAD_NUMBER_OF_LOADS]: 1,
  [GC.FIELD_LOAD_TYPE]: GC.LOAD_TYPE_CLO,
  telCreationMode: GC.TEL_CREATION_MODE_SINGLE_TEL,
  [GC.SYSTEM_OBJECT_BILL_TO]: R.assoc('isValid', false, defaultBillToFields),
  //
  aiRecognize: {
    data: null,
    loading: false,
    parseDocument: null,
  },
};

const templateData = {
  rateBackup: null,
  [GC.FIELD_RATE]: null,
  ratePreviewFiles: null,
  pageType: PAGE_TYPE_CLO_TEMPLATE,
  [GC.FIELD_LOAD_NUMBER_OF_LOADS]: 1,
  [GC.FIELD_LOAD_TYPE]: GC.LOAD_TYPE_CLO,
  telCreationMode: GC.TEL_CREATION_MODE_SINGLE_TEL,
  [GC.SYSTEM_OBJECT_BILL_TO]: R.assoc('isValid', false, defaultBillToFields),
};

const createNewDOPickup = (order) => ({
  order,
  isValid: false,
  id: G.generateGuid(),
  [GC.FIELD_DISTANCE_CLO]: null,
  formData: getDefaultPickupFields(),
  [GC.FIELD_EVENT_TYPE]: GC.EVENT_TYPE_PICKUP,
});

const createNewDODrop = (order) => ({
  order,
  isValid: false,
  id: G.generateGuid(),
  [GC.FIELD_DISTANCE_CLO]: null,
  formData: getDefaultDropFields(),
  [GC.FIELD_EVENT_TYPE]: GC.EVENT_TYPE_DROP,
});

const createNewStop = (stopType, stopOrder, branchDefaultItem, store) => {
  if (R.equals(stopType, GC.EVENT_TYPE_PICKUP)) {
    const newStop = createNewDOPickup(stopOrder);
    const withDates = G.getBranchNewStopDateTimeDefaultValues(stopType, store);

    let newFormData = R.mergeRight(newStop.formData, withDates);

    if (G.isNotNilAndNotEmpty(branchDefaultItem)) {
      const itemInternalId = G.generateGuid();
      const itemWithInternalId = R.assoc(GC.FIELD_ITEM_INTERNAL_ID, itemInternalId, branchDefaultItem);

      newFormData = R.assoc(GC.FIELD_LOAD_ITEMS, R.of(Array, itemWithInternalId), newFormData);
    }

    return R.assoc('formData', newFormData, newStop);
  }
  const newStop = createNewDODrop(stopOrder);
  const withDates = G.getBranchNewStopDateTimeDefaultValues(stopType, store);
  const newFormData = R.mergeRight(newStop.formData, withDates);

  return R.assoc('formData', newFormData, newStop);
};

const createNewStopWithContainers = (stopType, stopOrder, store) => {
  const { branchDefaultItem } = store;

  if (R.equals(stopType, GC.EVENT_TYPE_PICKUP)) {
    const newStop = createNewDOPickup(stopOrder);
    const withDates = G.getBranchNewStopDateTimeDefaultValues(stopType, store);
    const newFormData = R.mergeRight(newStop.formData, withDates);
    const firstPickupContainerInternalId = P.$get('stops.1.formData.pickedUpContainers.0.containerInternalId', store);
    const itemInternalId = G.generateGuid();

    const item = {
      ...branchDefaultItem,
      itemInternalId,
      containerInternalId: firstPickupContainerInternalId,
    };

    const formDataWithItem = R.assoc('items', R.of(Array, item), newFormData);

    return R.assoc('formData', formDataWithItem, newStop);
  }

  const newStop = createNewDODrop(stopOrder);
  const withDates = G.getBranchNewStopDateTimeDefaultValues(stopType, store);
  const newFormData = R.mergeRight(newStop.formData, withDates);

  return R.assoc('formData', newFormData, newStop);
};

const pageTypeToInitialDataMap = {
  [PAGE_TYPE_CREATE_DO]: createDOData,
  [PAGE_TYPE_CLO_TEMPLATE]: templateData,
};

const getInitialState = (pageType, sourceType = GC.CREATE_DO_SOURCE_TYPE_MANUAL) => {
  const pickup1 = createNewDOPickup(1);
  const drop1 = createNewDODrop(2);
  const initial = R.prop(pageType, pageTypeToInitialDataMap);
  const initData = R.mergeRight(staticData, initial);

  return R.mergeRight(
    initData,
    {
      sourceType,
      stops: {
        1: pickup1,
        2: drop1,
      },
    },
  );
};

const setValueToStore = (state, { path, value }) => (
  P.$set(path, value, state)
);

const setActiveLeftTab = (state, data) => (
  P.$set('leftActiveTab', data, state)
);

const setActiveRightTab = (state, data) => (
  P.$set('rightActiveTab', data, state)
);

const setNumberOfLoads = (state, data) => (
  P.$set('numberOfLoads', data, state)
);

const toggleHotOrder = (state) => (
  P.$toggle('hotOrder', state)
);

const setBranchBillTo = (state, data) => {
  if (G.isNilOrEmpty(data)) return state;

  const payTermsConfig = G.getConfigValueFromStore(GC.CLO_GENERAL_PAYMENT_TERMS, state.branchConfigs);
  const payTerms = G.ifElse(
    G.isNotNilAndNotEmpty(payTermsConfig),
    payTermsConfig,
    '',
  );

  const billTo = {
    ...data,
    'defaultBillTo': true,
    [GC.FIELD_PAYMENT_TERM]: payTerms,
    [GC.FIELD_STATE]: G.getStateValueByConfig(R.prop(GC.FIELD_STATE, data)),
  };

  return P.$set('billTo', billTo, state);
};

const setBranchShipFrom = (state, data) => (
  P.$set(
    'stops.1.formData',
    R.mergeRight(
      R.mergeRight(
        R.pathOr({}, ['stops', 1, 'formData'], state),
        { ...data, [GC.FIELD_STATE]: G.getStateValueByConfig(R.prop(GC.FIELD_STATE, data)) },
      ),
      G.getBranchPickupDateTimeDefaultValues(state.branchConfigs),
    ),
    state,
  )
);

const setBranchShipTo = (state, data) => (
  P.$set(
    'stops.2.formData',
    R.mergeRight(
      R.mergeRight(
        R.pathOr({}, ['stops', 2, 'formData'], state),
        { ...data, [GC.FIELD_STATE]: G.getStateValueByConfig(R.prop(GC.FIELD_STATE, data)) },
      ),
      G.getBranchDropDateTimeDefaultValues(state.branchConfigs),
    ),
    state,
  )
);

const setBranchDefaultItem = (state, data) => {
  let defaultItem = data;

  const configs = G.getItemFromWindow('amousNewDoBranchConfigs');
  const useContainers = G.isTrue(G.getConfigValueFromStore(GC.CLO_GENERAL_USE_CONTAINERS, configs));

  if (useContainers) {
    defaultItem = R.assoc(GC.FIELD_CONTAINER_INTERNAL_ID, '', defaultItem);
  }

  const palletSpaces = G.getPropFromObject(GC.FIELD_PALLET_SPACES, defaultItem);
  const billableWeight = G.getPropFromObject(GC.FIELD_BILLABLE_WEIGHT, defaultItem);

  if (R.and(palletSpaces, G.isNilOrEmpty(billableWeight))) {
    const configBillableWeight = G.getConfigValueFromStore(GC.CLO_ITEM_BILLABLE_WEIGHT_PER_PALLET_SPACE, configs);

    if (configBillableWeight) {
      defaultItem = R.assoc(
        GC.FIELD_BILLABLE_WEIGHT,
        G.calculateBillableWeight(palletSpaces, configBillableWeight),
        defaultItem,
      );
    }
  }

  const itemInternalId = G.generateGuid();
  const itemWithInternalId = R.assoc(GC.FIELD_ITEM_INTERNAL_ID, itemInternalId, defaultItem);
  const autoCreateContainerItem = G.getConfigValueFromStore(GC.CLO_GENERAL_AUTO_CREATE_CONTAINER_ITEM, configs);

  if (R.and(useContainers, autoCreateContainerItem)) {
    return P.$set('branchDefaultItem', defaultItem, state);
  }

  return P.$all(
    P.$set('branchDefaultItem', defaultItem),
    P.$set('stops.1.formData.items', R.of(Array, itemWithInternalId)),
    P.$set('stops.2.formData.items', R.of(Array, itemInternalId)),
    state,
  );
};

const stopDatesApptsFields = [
  GC.FIELD_LOAD_FCFS,
  GC.FIELD_STOP_NUMBER,
  GC.FIELD_LOAD_EVENT_LATE_TIME,
  GC.FIELD_LOAD_EVENT_LATE_DATE,
  GC.FIELD_LOAD_EVENT_EARLY_TIME,
  GC.FIELD_LOAD_EVENT_EARLY_DATE,
  GC.FIELD_LOAD_APPOINTMENT_DATE,
  GC.FIELD_LOAD_APPOINTMENT_NUMBER,
  GC.FIELD_LOAD_APPOINTMENT_REQUIRED,
  GC.FIELD_LOAD_APPOINTMENT_LATE_TIME,
  GC.FIELD_LOAD_APPOINTMENT_EARLY_TIME,
];


const getContainersFromEvent = (event) => {
  const droppedContainers = R.pathOr([], [GC.FIELD_STOP_DROPPED_CONTAINERS], event);
  const pickedUpContainers = R.pathOr([], [GC.FIELD_STOP_PICKED_UP_CONTAINERS], event);

  return { droppedContainers, pickedUpContainers };
};

const mapDataEvent = (event, withOutData = false) => {
  const {
    items,
    location,
    eventType,
    internalId,
    references,
    stopNumber,
    dropTrailer,
    cloEventIndex,
    appointmentContact,
    droppedTrailerGuids,
    pickedUpTrailerGuids,
  } = event;

  const datesAppts = R.pick(stopDatesApptsFields, event);
  const containers = getContainersFromEvent(event);

  const createStopFunc = G.ifElse(
    G.isEventTypePickup(eventType),
    createNewDOPickup,
    createNewDODrop,
  );

  const itemsToUse = G.ifElse(
    G.isEventTypePickup(eventType),
    items,
    R.map((item) => R.prop(GC.FIELD_ITEM_INTERNAL_ID, item), items),
  );

  const init = createStopFunc(cloEventIndex);

  const contacts = G.getPropFromObject(GC.FIELD_CONTACTS, location);
  const state = G.getStateValueByConfig(R.prop(GC.FIELD_STATE, location));

  const contactsToUse = G.isNotNilAndNotEmpty(contacts)
    ? R.map(G.mapObjectNullFieldsToEmptyStrings, G.mapOmitObjectSystemFields(contacts))
    : contacts;

  if (withOutData) {
    const newFormData = {
      ...init.formData,
      ...G.resetLocationTypeFromDropdownOption(location),
      ...containers,
      state,
      dropTrailer,
      items: itemsToUse,
      droppedTrailerGuids,
      pickedUpTrailerGuids,
      contacts: contactsToUse,
    };

    return R.assoc('formData', G.mapObjectNullFieldsToEmptyStrings(newFormData), init);
  }

  const appointmentContactToUse = G.isNotNilAndNotEmpty(appointmentContact)
    ? G.mapObjectNullFieldsToEmptyStrings(appointmentContact)
    : init.formData.appointmentContact;

  const referencesToUse = G.isNotNilAndNotEmpty(references)
    ? R.map(G.mapObjectNullFieldsToEmptyStrings, references)
    : [];

  const newFormData = {
    ...init.formData,
    ...G.resetLocationTypeFromDropdownOption(location),
    ...datesAppts,
    ...containers,
    state,
    internalId,
    stopNumber,
    dropTrailer,
    items: itemsToUse,
    droppedTrailerGuids,
    pickedUpTrailerGuids,
    contacts: contactsToUse,
    references: referencesToUse,
    appointmentContact: appointmentContactToUse,
  };

  return R.assoc('formData', G.mapObjectNullFieldsToEmptyStrings(newFormData), init);
};

const mapDataEvents = (events, withOutData = false) => R.compose(
  R.indexBy(R.prop(GC.FIELD_ORDER)),
  R.map((item) => mapDataEvent(item, withOutData)),
)(events);

const getBillToFromData = (state, dataBillTo, branchConfigs) => {
  const { billTo } = state;

  const payTerms = G.getConfigValueFromStore(GC.CLO_GENERAL_PAYMENT_TERMS, branchConfigs);
  const billToWithTerms = R.assoc(GC.FIELD_PAYMENT_TERM, payTerms, billTo);

  if (G.isObject(dataBillTo)) {
    return G.resetLocationTypeFromDropdownOption({
      ...billToWithTerms,
      ...dataBillTo,
      defaultBillTo: true,
      [GC.FIELD_STATE]: G.getStateValueByConfig(R.prop(GC.FIELD_STATE, dataBillTo)),
    });
  }

  return G.resetLocationTypeFromDropdownOption(billToWithTerms);
};

const getRateFromData = (rate, branchConfigs, isValid, billTo, shared) => {
  if (G.isNilOrEmpty(rate)) return null;

  const currency = G.getConfigValueFromStore(GC.GENERAL_BRANCH_DEFAULT_CURRENCY, branchConfigs);
  const mode = G.getConfigValueFromStore(GC.CLO_GENERAL_RATE_TRANSPORTATION_MODE, branchConfigs);

  const rateContact = R.pick(
    [GC.FIELD_FAX, GC.FIELD_PHONE, GC.FIELD_EMAIL, GC.FIELD_CONTACT_NAME],
    rate,
  );

  const init = {
    isValid,
    rateContact,
    [GC.FIELD_MODE]: mode,
    [GC.FIELD_CURRENCY]: currency,
  };

  const rateWithCharges = R.mergeRight(init, mapRateInitChargesWithFuelIndexInfo(rate, shared));

  return R.mergeRight(rateWithCharges, billTo);
};

const getReferenceFormDataFromTemplate = (template, branchConfigs) => {
  const additionalReferenceTypeGuid = G.getConfigValueFromStore(GC.CLO_ADDITIONAL_REFERENCE_TYPE, branchConfigs);

  const additionalReferenceAutogenerated = G.getConfigValueFromStore(
    GC.CLO_ADDITIONAL_REFERENCE_AUTOGENERATED,
    branchConfigs,
);

  let references = R.map(
    (item) => R.pick([GC.FIELD_VALUE, GC.FIELD_REFERENCE_TYPE_GUID], item),
    R.pathOr([], [GC.FIELD_LOAD_REFERENCES], template),
  );

  if (additionalReferenceAutogenerated) {
    references = R.append(
      {
        isAdditional: true,
        [GC.FIELD_REFERENCE_TYPE_GUID]: additionalReferenceTypeGuid,
      },
      references,
    );
  }

  return {
    references,
    isValid: true,
    [GC.FIELD_FAST_LOAD]: R.path([GC.FIELD_FAST_LOAD], template),
    [GC.FIELD_PINNED_NOTE]: R.path([GC.FIELD_PINNED_NOTE], template),
    [GC.FIELD_LOAD_SPECIAL_INSTRUCTIONS]: R.path([GC.FIELD_LOAD_SPECIAL_INSTRUCTIONS], template),
    [GC.FIELD_LOAD_INTERNAL_INSTRUCTIONS]: R.path([GC.FIELD_LOAD_INTERNAL_INSTRUCTIONS], template),
  };
};

const getBranchConfigsWithTemplateSuccess = (state, data) => {
  const { branchGuid, templateData, branchConfigs } = data;

  const { hot, rate, billTo, events, orderType, divisionGuid } = templateData;

  const { branchList, sharedAccessorialsList } = state;

  const branchInfo = R.find(R.propEq(branchGuid, GC.FIELD_GUID), branchList);

  const branchInfoMapped = {
    value: R.prop(GC.FIELD_GUID, branchInfo),
    label: R.prop(GC.FIELD_NAME, branchInfo),
  };

  const billToUse = getBillToFromData(state, billTo, branchConfigs);

  const rateToUse = getRateFromData(rate, branchConfigs, false, billToUse, sharedAccessorialsList);

  const orderTypeToUse = G.getDropdownOptionGuidFromObject(orderType);

  G.setItemToWindow('amousNewDoBranchConfigs', branchConfigs);

  return P.$all(
    P.$set('hotOrder', hot),
    P.$set('rate', rateToUse),
    P.$set('rateBackup', rateToUse),
    P.$set('templateData', templateData),
    P.$set('divisionGuid', divisionGuid),
    P.$set('stops', mapDataEvents(events)),
    P.$set('branchInfo', branchInfoMapped),
    P.$set('branchConfigs', branchConfigs),
    P.$set('numberOfLoads', R.pathOr(1, [GC.FIELD_NUMBER_OF_LOADS], templateData)),
    P.$set('orderType', R.or(orderTypeToUse, G.getPropFromObject('orderType', state))),
    P.$set('referenceFormData', getReferenceFormDataFromTemplate(templateData, branchConfigs)),
    state,
  );
};

const getReferenceFormDataFromDuplicateDO = (data, branchConfigs) => {
  let references = [];

  const defaultReferences = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_REFERENCES, branchConfigs);

  if (G.isNotNilAndNotEmpty(defaultReferences)) {
    references = R.map((item) => ({
      [GC.FIELD_VALUE]: null,
      [GC.FIELD_REFERENCE_TYPE_GUID]: item,
    }), defaultReferences);
  }

  return ({
    isValid: true,
    [GC.FIELD_LOAD_REFERENCES]: references,
    [GC.FIELD_LOAD_SPECIAL_INSTRUCTIONS]: R.path([GC.FIELD_LOAD_SPECIAL_INSTRUCTIONS], data),
  });
};

const getBranchConfigsOnDuplicateDOSuccess = (state, data) => {
  const { branchGuid, branchConfigs, duplicateDOData } = data;

  const { rate, billTo, events } = duplicateDOData;

  const { branchList } = state;

  const branchInfo = R.find(R.propEq(branchGuid, GC.FIELD_GUID), branchList);

  const branchInfoMapped = {
    value: R.prop(GC.FIELD_GUID, branchInfo),
    label: R.prop(GC.FIELD_NAME, branchInfo),
  };

  const billToUse = getBillToFromData(state, billTo, branchConfigs);

  const rateToUse = getRateFromData(rate, branchConfigs, true, billToUse);

  G.setItemToWindow('amousNewDoBranchConfigs', branchConfigs);

  return P.$all(
    P.$set('rate', rateToUse),
    P.$set('rateBackup', rateToUse),
    P.$set('duplicateDO', duplicateDOData),
    P.$set('branchInfo', branchInfoMapped),
    P.$set('branchConfigs', branchConfigs),
    P.$set('stops', mapDataEvents(events, true)),
    P.$set('sourceType', GC.CREATE_DO_SOURCE_TYPE_COPY),
    P.$set('numberOfLoads', R.pathOr(1, [GC.FIELD_NUMBER_OF_LOADS], duplicateDOData)),
    P.$set('referenceFormData', getReferenceFormDataFromDuplicateDO(duplicateDOData, branchConfigs)),
    state,
  );
};

const mapEventsWithTimes = (events) => (
  R.map((item) => G.setEventEarlyLateTimeFromEarlyLateDate2(item),
  events,
));

const copyTemplateDataToStore = (state, data) => {
  const { branchConfigs, sharedAccessorialsList } = state;

  const { rate, billTo, events, orderType } = data;

  const eventsToUse = mapEventsWithTimes(events);

  const billToUse = getBillToFromData(state, billTo, branchConfigs);

  const rateToUse = getRateFromData(rate, branchConfigs, false, billToUse, sharedAccessorialsList);

  const orderTypeToUse = G.getDropdownOptionGuidFromObject(orderType);

  return P.$all(
    P.$set('rate', rateToUse),
    P.$set('templateData', data),
    P.$set('rateBackup', rateToUse),
    P.$set('stops', mapDataEvents(eventsToUse)),
    P.$set('numberOfLoads', R.pathOr(1, [GC.FIELD_NUMBER_OF_LOADS], data)),
    P.$set('referenceFormData', getReferenceFormDataFromTemplate(data, branchConfigs)),
    P.$set('orderType', R.or(orderTypeToUse, G.getPropFromObject('orderType', state))),
    state,
  );
};

const setItemOrContainer = (useContainers, branchConfigs, state) => {
  if (G.isTrue(useContainers)) {
    const withContainers = R.assocPath(
      [GC.FIELD_STOP_PICKED_UP_CONTAINERS, 0],
      getNewContainerFields(),
      state,
    );

    return R.assoc('items', [], withContainers);
  }

  return R.assocPath(
    ['items', 0],
    getNewItemFields(branchConfigs),
    state,
  );
};

const setDefaultLocationTypeToValues = (values, locationType) => {
  if (G.isNilOrEmpty(locationType)) return values;

  return R.assoc(GC.FIELD_LOCATION_TYPE, locationType, values);
};

const getBranchConfigsSuccess = (state, data) => {
  if (R.includes(
    state.pageType,
    [
      PAGE_TYPE_CLO_TEMPLATE,
    ],
  )) return state;

  const { branchRefTypes } = state;

  const { branchConfigs } = data;

  const primaryReference = getPrimaryReference(branchConfigs, branchRefTypes);

  const useContainers = G.getConfigValueFromStore(GC.CLO_GENERAL_USE_CONTAINERS, branchConfigs);
  const autoCreateContainerItem = G.getConfigValueFromStore(GC.CLO_GENERAL_AUTO_CREATE_CONTAINER_ITEM, branchConfigs);
  const defaultReferences = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_REFERENCES, branchConfigs);
  const defaultEquipment = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_EQUIPMENT, branchConfigs);
  const defaultOrderType = G.getConfigValueFromStore(GC.CLO_GENERAL_DEFAULT_ORDER_TYPE, branchConfigs);
  const defaultPickupLocationType = G.getConfigValueFromStore(GC.CLO_DEFAULT_PICKUP_LOCATION_TYPE, branchConfigs);
  const defaultSpecialInstruction = G.getConfigValueFromStore(GC.CLO_DEFAULT_SPECIAL_INSTRUCTION, branchConfigs);
  const defaultDropLocationType = G.getConfigValueFromStore(GC.CLO_DEFAULT_DROP_LOCATION_TYPE, branchConfigs);
  const additionalReference = G.getConfigValueFromStore(GC.CLO_ADDITIONAL_REFERENCE_TYPE, branchConfigs);

  const additionalReferencesAutogenerated = G.getConfigValueFromStore(
    GC.CLO_ADDITIONAL_REFERENCE_AUTOGENERATED,
    branchConfigs,
  );

  const withPickupDates = R.mergeRight(
    R.pathOr({}, ['stops', 1, 'formData'], state),
    setDefaultLocationTypeToValues(G.getBranchPickupDateTimeDefaultValues(branchConfigs), defaultPickupLocationType),
  );

  const withDefaultItemOrContainer = setItemOrContainer(useContainers, branchConfigs, withPickupDates);

  const withDropDates = R.mergeRight(
    R.pathOr({}, ['stops', 2, 'formData'], state),
    setDefaultLocationTypeToValues(G.getBranchDropDateTimeDefaultValues(branchConfigs), defaultDropLocationType),
  );

  G.setItemToWindow('amousNewDoBranchConfigs', branchConfigs);

  let references = [];

  if (G.isNotNilAndNotEmpty(defaultReferences)) {
    references = R.map((item) => ({
      [GC.FIELD_VALUE]: null,
      [GC.FIELD_REFERENCE_TYPE_GUID]: item,
    }), defaultReferences);
  }

  if (additionalReferencesAutogenerated) {
    references = R.append(
      {
        isAdditional: true,
        [GC.FIELD_REFERENCE_TYPE_GUID]: additionalReference,
      },
      references,
    );
  }

  return P.$all(
    P.$set('orderType', defaultOrderType),
    P.$set('useContainers', useContainers),
    P.$set('branchConfigs', branchConfigs),
    P.$set('stops.2.formData', withDropDates),
    P.$set('primaryReference', primaryReference),
    P.$set('referenceFormData.references', references),
    P.$set('stops.1.formData', withDefaultItemOrContainer),
    P.$set('autoCreateContainerItem', autoCreateContainerItem),
    P.$set('billTo', getBillToFromData(state, null, branchConfigs)),
    P.$set('referenceFormData.equipment', R.or(defaultEquipment, null)),
    P.$set('referenceFormData.specialInstructions', R.or(defaultSpecialInstruction, null)),
    state,
  );
};

const setEdiFileToStore = (state, data) => (
  P.$set('ediFile', data, state)
);

const setRatePreviewFiles = (state, data) => {
  if (G.isNilOrEmpty(data)) {
    G.setItemToWindow('amousCreateDoRateConfirmationFiles', data);

    return P.$set('ratePreviewFiles', data, state);
  }

  const currentFiles = R.or(G.getItemFromWindow('amousCreateDoRateConfirmationFiles'), []);
  const files = R.concat(currentFiles, data);

  const filesWithPreview = R.map((file) => R.assoc('preview', URL.createObjectURL(file), file), files);

  G.setItemToWindow('amousCreateDoRateConfirmationFiles', files);

  return P.$set('ratePreviewFiles', filesWithPreview, state);
};

const setFormDataToStop = (state, data) => P.$all(
  P.$set(`stops.${data.stopOrder}.isValid`, data.isValid),
  P.$set(`stops.${data.stopOrder}.formData`, data.formData),
  state,
);

const setFormDataToStore = (state, data) => {
  const { dataName, formData } = data;

  if (R.equals(dataName, 'rate')) {
    return P.$all(
      P.$set('rate', formData),
      P.$set('rateBackup', formData),
      state,
    );
  }

  return P.$set(dataName, formData, state);
};

const setCustomerRateToStore = (state, data) => (
  P.$set('rate', data, state)
);

const setCustomerRateIsValidToStore = (state, data) => {
  const { rate, rateBackup } = state;

  if (G.isAnyNilOrEmpty([rate, rateBackup])) return state;

  return P.$all(
    P.$set('rate.isValid', data),
    P.$set('rateBackup.isValid', data),
    state,
  );
};

const setCustomerRateChargesToStore = (state, data) => {
  const { rate, telDriverRate } = state;

  if (G.isNilOrEmpty(rate)) {
    const fields = R.map(R.prop('fieldName'), allCustomerFormFields);
    const rate = R.assoc(
      GC.FIELD_CHARGES,
      data,
      R.pick(fields, telDriverRate),
    );

    return P.$set('rate', rate, state);
  }

  return P.$all(
    P.$set('rate.charges', data),
    P.$set('rateBackup.charges', data),
    state,
  );
};

const setDriverRateToStore = (state, data) => (
  P.$set('telDriverRate', data, state)
);

const addNewStopToStore = (state, stopType) => {
  const {
    stops,
    pageType,
    sourceType,
    useContainers,
    branchDefaultItem,
    addedNewFirstDrop,
    addedNewFirstPickup,
    autoCreateContainerItem,
  } = state;

  if (R.and(
    G.isAllTrue(
      useContainers,
      autoCreateContainerItem,
      isPageCreateDO(pageType),
      G.isEventTypePickup(stopType),
      isSourceTypeEdiOrManual(sourceType),
      G.isNotNilAndNotEmpty(branchDefaultItem),
    ),
    G.isAllFalse(
      addedNewFirstDrop,
      addedNewFirstPickup,
    ),
  )) {
    const stopOrder = 2;
    const stop = createNewStopWithContainers(stopType, stopOrder, state);
    const stopsWithAdded = R.insert(1, stop, R.values(stops));
    const newStops = R.compose(
      R.indexBy(R.prop(GC.FIELD_ORDER)),
      G.mapIndexed((stop, index) => R.assoc(GC.FIELD_ORDER, R.inc(index), stop)),
    )(stopsWithAdded);

    const firstPickupContainerInternalId = P.$get('1.formData.pickedUpContainers.0.containerInternalId', newStops);
    const secondPickupItemInternalId = P.$get('2.formData.items.0.itemInternalId', newStops);
    const secondPickupEventEarlyDate = P.$get('2.formData.eventEarlyDate', newStops);
    const secondPickupEventLateDate = P.$get('2.formData.eventLateDate', newStops);
    const dropEventEarlyDate = P.$get('3.formData.eventEarlyDate', newStops);
    const dropEventLateDate = P.$get('3.formData.eventLateDate', newStops);

    const newStops2 = P.$all(
      P.$set('3.formData.items', R.of(Array, secondPickupItemInternalId)),
      P.$set('3.formData.droppedContainers', R.of(Array, firstPickupContainerInternalId)),
      P.$set('3.formData.eventEarlyDate', secondPickupEventEarlyDate),
      P.$set('3.formData.eventLateDate', secondPickupEventLateDate),
      P.$set('2.formData.eventEarlyDate', dropEventEarlyDate),
      P.$set('2.formData.eventLateDate', dropEventLateDate),
      newStops,
    );

    return P.$all(
      P.$set('stops', newStops2),
      P.$toggle('addedNewFirstPickup'),
      state,
    );
  }

  if (R.and(
    G.isAllTrue(
      useContainers,
      autoCreateContainerItem,
      isPageCreateDO(pageType),
      G.isEventTypeDrop(stopType),
      isSourceTypeEdiOrManual(sourceType),
      G.isNotNilAndNotEmpty(branchDefaultItem),
    ),
    G.isAllFalse(
      addedNewFirstDrop,
      addedNewFirstPickup,
    ),
  )) {
    const stopOrder = 3;
    const stop = createNewStopWithContainers(stopType, stopOrder, state);
    const stopsWithAdded = R.append(stop, R.values(stops));
    const newStops = R.compose(
      R.indexBy(R.prop(GC.FIELD_ORDER)),
      G.mapIndexed((stop, index) => R.assoc(GC.FIELD_ORDER, R.inc(index), stop)),
    )(stopsWithAdded);

    const firstPickupContainerInternalId = P.$get('1.formData.pickedUpContainers.0.containerInternalId', newStops);

    const itemInternalId = G.generateGuid();
    const item = {
      ...branchDefaultItem,
      itemInternalId,
      containerInternalId: firstPickupContainerInternalId,
    };

    const newStops2 = P.$set('1.formData.items', R.of(Array, item), newStops);

    const newStops3 = P.$all(
      P.$set('2.formData.items', R.of(Array, itemInternalId)),
      P.$set('3.formData.droppedContainers', R.of(Array, firstPickupContainerInternalId)),
      newStops2,
    );

    return P.$all(
      P.$set('stops', newStops3),
      P.$toggle('addedNewFirstDrop'),
      state,
    );
  }

  const stopOrder = R.inc(R.length(R.values(state.stops)));
  const stop = createNewStop(stopType, stopOrder, branchDefaultItem, state);

  return P.$set(`stops.${stopOrder}`, stop, state);
};

const removeStopFromStore = (state, stopOrder) => {
  const stops = R.compose(
    R.indexBy(R.prop(GC.FIELD_ORDER)),
    G.mapIndexed((item, index) => R.assoc(GC.FIELD_ORDER, R.inc(index), item)),
    R.reject((item) => R.equals(R.prop(GC.FIELD_ORDER, item), stopOrder)),
    R.sortBy(R.prop(GC.FIELD_ORDER)),
    R.values(),
  )(state.stops);

  return P.$all(
    P.$set('stops', stops),
    P.$set('leftActiveTab', 1),
    state,
  );
};

const removeItemFromStore = (state, itemInternalId) => {
  const stops = R.compose(
    R.indexBy(R.prop(GC.FIELD_ORDER)),
    R.map((stop) => {
      const { formData: { items }, eventType } = stop;

      if (G.isEventTypeDrop(eventType)) {
        const newItems = R.without([itemInternalId], items);

        return R.assocPath(['formData', GC.FIELD_LOAD_ITEMS], newItems, stop);
      }

      return stop;
    }),

    R.values(),
  )(state.stops);

  return P.$set('stops', stops, state);
};

const removeContainerFromStore = (state, { stopId, values, internalId }) => {
  const stops = R.compose(
    R.indexBy(R.prop(GC.FIELD_ORDER)),
    R.map((stop) => {
      const { id, formData: { items, droppedContainers, pickedUpContainers } } = stop;

      const isCurrentStop = R.equals(id, stopId);
      const currentItems = G.ifElse(isCurrentStop, G.getPropFromObject(GC.FIELD_LOAD_ITEMS, values), items);

      const currentDroppedContainers = G.ifElse(
        isCurrentStop,
        G.getPropFromObject(GC.FIELD_STOP_DROPPED_CONTAINERS, values),
        droppedContainers,
      );

      const currentPickedUpContainers = G.ifElse(
        isCurrentStop,
        G.getPropFromObject(GC.FIELD_STOP_PICKED_UP_CONTAINERS, values),
        pickedUpContainers,
      );

      let newStop = isCurrentStop ? R.assoc('formData', values, stop) : stop;

      if (G.isNotNilAndNotEmpty(currentDroppedContainers)) {
        const newDroppedContainers = R.reject(
          R.either(R.equals(internalId), R.propEq(internalId, GC.FIELD_CONTAINER_INTERNAL_ID)),
          currentDroppedContainers,
        );

        newStop = R.assocPath(['formData', GC.FIELD_STOP_DROPPED_CONTAINERS], newDroppedContainers, newStop);
      }

      if (G.isNotNilAndNotEmpty(currentPickedUpContainers)) {
        const newPickedUpContainers = R.reject(
          R.propEq(internalId, GC.FIELD_CONTAINER_INTERNAL_ID),
          currentPickedUpContainers,
        );

        newStop = R.assocPath(['formData', GC.FIELD_STOP_PICKED_UP_CONTAINERS], newPickedUpContainers, newStop);
      }

      if (G.isNotNilAndNotEmpty(currentItems)) {
        const newItems = R.map((item) => {
          if (G.isObject(item)) {
            const { containerInternalId } = item;

            if (R.equals(internalId, containerInternalId)) {
              return R.mergeRight(item, {
                [GC.FIELD_CONTAINER_GUID]: null,
                [GC.FIELD_CONTAINER_NUMBER]: null,
                [GC.FIELD_CONTAINER_INTERNAL_ID]: '',
              });
            }
          }

          return item;
        }, currentItems);

        newStop = R.assocPath(['formData', GC.FIELD_LOAD_ITEMS], newItems, newStop);
      }

      return newStop;
    }),
    R.values(),
  )(state.stops);

  return P.$set('stops', stops, state);
};

const setReorderedStops = (state, data) => (
  P.$set('stops', data, state)
);

const recalculateLoadDistancesSuccess = (state, data) => {
  const { distance, stopPoints, mappedStops } = data;

  if (G.isNotNilAndNotEmpty(distance)) {
    const rate = R.mergeRight(state.rateBackup, distance);

    const rateWithValid = R.assoc('isValid', isValidBillToCustomerRateForm(rate), rate);

    const stopPointsStrings = getStopPointsLatLonStringsArray(stopPoints);

    return P.$all(
      P.$set('stops', mappedStops),
      P.$set('rate', rateWithValid),
      P.$set('rateBackup', rateWithValid),
      P.$set('stopPointsStrings', stopPointsStrings),
      state,
    );
  }

  return P.$set('stops', mappedStops, state);
};

const getBranchListSuccess = (state, data) => (
  P.$set('branchList', data, state)
);

const getPrimaryRefSequenceSuccess = (state, data) => P.$all(
  P.$set('primaryRefSequence', data),
  P.$set('customerLoadNumber', createCustomerLoadNumber({
    sequence: data,
    configs: state.branchConfigs,
    divisionPrefix: state.divisionPrefix,
  })),
  state,
);

const getAdditionalRefSequenceSuccess = (state, { data, duplicate }) => {
  const { branchConfigs } = state;

  const { prefix, suffix, approxValue } = data;

  const additionalReferenceValue = G.createStringFromArray([prefix, approxValue, suffix], '');

  if (duplicate) {
    const additionalReferenceTypeGuid = G.getConfigValueFromStore(
      GC.CLO_ADDITIONAL_REFERENCE_TYPE,
      branchConfigs,
    );

    const references = [
      {
        isAdditional: true,
        originalValue: additionalReferenceValue,
        [GC.FIELD_VALUE]: additionalReferenceValue,
        [GC.FIELD_REFERENCE_TYPE_GUID]: additionalReferenceTypeGuid,
      },
    ];

    return P.$set('referenceFormData.references', references, state);
  }

  const references = R.map((item) => {
    const { isAdditional } = item;

    if (isAdditional) {
      return {
        ...item,
        originalValue: additionalReferenceValue,
        [GC.FIELD_VALUE]: additionalReferenceValue,
      };
    }

    return item;
  }, R.pathOr([], ['referenceFormData', 'references'], state));

  return P.$set('referenceFormData.references', references, state);
};

const setCustomerLoadNumberByBranchConfigs = (state, { configs }) => {
  const divisionPrefix = G.getConfigValueFromStore(
    GC.CLO_PRIMARY_REFERENCE_DIVISION_PREFIX,
    configs,
  );

  return P.$all(
    P.$set('divisionPrefix', divisionPrefix),
    P.$set('customerLoadNumber', createCustomerLoadNumber({
      divisionPrefix,
      configs: state.branchConfigs,
      sequence: state.primaryRefSequence,
    })),
    state,
  );
};

const getAllAvBranchRefTypesSuccess = (state, { scopeName, data }) => (
  P.$set(`branchRefTypes.${scopeName}`, data, state)
);

const setCustomerLoadNumber = (state, value) => (
  P.$set('customerLoadNumber', value, state)
);

const setDivisionGuid = (state, value) => (
  P.$set('divisionGuid', value, state)
);

const setPageTypeToStore = (state, value) => (
  P.$set('pageType', value, state)
);

const saveAndDuplicateSuccess = (state) => (
  P.$all(
    P.$set('ignoreWarnings', false),
    P.$set('validationWarnings', null),
    P.$set('referenceFormData.references', []),
    P.$set('saveAndDuplicateQty', R.inc(state.saveAndDuplicateQty)),
    state,
  )
);

const setBranchInfo = (state, data) => G.ifElse(
  R.isNil(data),
  P.$set('branchInfo', GC.EMPTY_OPTION_OBJECT, state),
  P.$set('branchInfo', data, state),
);

const setPrimaryReference = (state, data) => (
  G.ifElse(
    R.isNil(data),
    P.$set('primaryReference', GC.EMPTY_OPTION_OBJECT, state),
    P.$set('primaryReference', data, state),
  )
);

const setValidationErrors = (state, data) => {
  if (G.isNotNilAndNotEmpty(data)) {
    return P.$set('validationErrors', data, state);
  }

  return state;
};

const setValidationErrorsAndWarnings = (state, { errors, warnings }) => (
  P.$all(
    P.$set('validationErrors', errors),
    P.$set('validationWarnings', warnings),
    state,
  )
);

const removeValidationErrors = (state) => (
  P.$set('validationErrors', null, state)
);

const removeValidationWarnings = (state) => (
  P.$set('validationWarnings', null, state)
);

const setIgnoreWarnings = (state, value = false) => (
  P.$all(
    P.$set('ignoreWarnings', value),
    P.$set('validationWarnings', G.ifElse(G.isTrue(value), null, state.validationWarnings)),
    state,
  )
);

const getBranchSharedAccessorialListSuccess = (state, data) => (
  P.$set('sharedAccessorialsList', data, state)
);

// ai recognize
const aiRecognizeSuccess = (state, data) => {
  try {
    const { branchConfigs } = state;

    const {
      rate,
      notes,
      items,
      billTo,
      events,
      containers,
      specialInstructions,
    } = data;

    const stops = mapRecognizeStopsData(events || [], items || [], containers || []);

    const rateToUse = getRateFromRecognizeData(rate, branchConfigs);

    const billToUse = getBillToFromRecognizeData(state, billTo);

    const mergedRateData = R.mergeRight(rateToUse, billToUse);

    return P.$all(
      P.$set('aiRecognize.data', data),
      //
      P.$set('rate', mergedRateData),
      P.$set('rateBackup', mergedRateData),
      //
      P.$set('stops', stops),
      //
      P.$set('referenceFormData.pinnedNote', notes),
      P.$set('referenceFormData.specialInstructions', specialInstructions),
      state,
    );
  } catch (error) {
    return state;
  }
};

const fetchStopLatLonSuccess = (state, payload) => {
  const { data, stopIndex } = payload;

  const { latitude, longitude } = data;

  if (G.isAllTrue(
    G.isNotNilAndNotEmpty(latitude),
    G.isNotNilAndNotEmpty(longitude),
    G.isNotNilAndNotEmpty(stopIndex),
  )) {
    const currentFormData = P.$get(`stops.${stopIndex}.formData`, state);

    const formData = R.mergeDeepRight(currentFormData, data);

    return P.$set(`stops.${stopIndex}.formData`, formData, state);
  }

  return state;
};
// ai recognize

const cleanNewDOStore = (state, data) => {
  const guid = R.path([GC.FIELD_GUID], data);
  const pageType = R.pathOr(state.pageType, ['pageType'], data);
  const sourceType = G.getPropFromObject(GC.FIELD_SOURCE_TYPE, data);

  let customerInfo = GC.EMPTY_OPTION_OBJECT;

  if (G.isNotNil(guid)) {
    customerInfo = {
      value: guid,
      label: data[GC.FIELD_BRANCH_NAME],
    };
  }
  const branchList = P.$get('branchList', state);

  return P.$all(
    P.$set('branchList', branchList),
    P.$set('branchInfo', customerInfo),
    getInitialState(pageType, sourceType),
  );
};

const setInitialStateToStore = () => (
  getInitialState(PAGE_TYPE_CREATE_DO)
);

const setETAConfigList = (state, data) => (
  P.$set('etaConfigList', data, state)
);

export default createReducer({
  [A.setBranchInfo]: setBranchInfo,
  [A.toggleHotOrder]: toggleHotOrder,
  [A.setDivisionGuid]: setDivisionGuid,
  [A.setBranchShipTo]: setBranchShipTo,
  [A.cleanNewDOStore]: cleanNewDOStore,
  [A.setBranchBillTo]: setBranchBillTo,
  [A.setValueToStore]: setValueToStore,
  [A.setNumberOfLoads]: setNumberOfLoads,
  [A.setActiveLeftTab]: setActiveLeftTab,
  [A.setEdiFileToStore]: setEdiFileToStore,
  [A.setActiveRightTab]: setActiveRightTab,
  [A.setBranchShipFrom]: setBranchShipFrom,
  [A.setReorderedStops]: setReorderedStops,
  [A.setFormDataToStop]: setFormDataToStop,
  [A.addNewStopToStore]: addNewStopToStore,
  [A.setIgnoreWarnings]: setIgnoreWarnings,
  [A.setPageTypeToStore]: setPageTypeToStore,
  [A.setFormDataToStore]: setFormDataToStore,
  [A.setRatePreviewFiles]: setRatePreviewFiles,
  [A.removeItemFromStore]: removeItemFromStore,
  [A.setValidationErrors]: setValidationErrors,
  [A.removeStopFromStore]: removeStopFromStore,
  [A.setPrimaryReference]: setPrimaryReference,
  [A.setBranchDefaultItem]: setBranchDefaultItem,
  [A.getBranchListSuccess]: getBranchListSuccess,
  [A.setDriverRateToStore]: setDriverRateToStore,
  [A.setCustomerLoadNumber]: setCustomerLoadNumber,
  [A.setInitialStateToStore]: setInitialStateToStore,
  [A.removeValidationErrors]: removeValidationErrors,
  [A.setCustomerRateToStore]: setCustomerRateToStore,
  [A.saveAndDuplicateSuccess]: saveAndDuplicateSuccess,
  [A.getBranchConfigsSuccess]: getBranchConfigsSuccess,
  [A.copyTemplateDataToStore]: copyTemplateDataToStore,
  [A.removeContainerFromStore]: removeContainerFromStore,
  [A.removeValidationWarnings]: removeValidationWarnings,
  [A.getPrimaryRefSequenceSuccess]: getPrimaryRefSequenceSuccess,
  [A.setCustomerRateIsValidToStore]: setCustomerRateIsValidToStore,
  [A.setCustomerRateChargesToStore]: setCustomerRateChargesToStore,
  [A.getAllAvBranchRefTypesSuccess]: getAllAvBranchRefTypesSuccess,
  [A.setValidationErrorsAndWarnings]: setValidationErrorsAndWarnings,
  [A.getAdditionalRefSequenceSuccess]: getAdditionalRefSequenceSuccess,
  [A.recalculateLoadDistancesSuccess]: recalculateLoadDistancesSuccess,
  [A.getBranchConfigsWithTemplateSuccess]: getBranchConfigsWithTemplateSuccess,
  [A.getBranchConfigsOnDuplicateDOSuccess]: getBranchConfigsOnDuplicateDOSuccess,
  [A.getBranchSharedAccessorialListSuccess]: getBranchSharedAccessorialListSuccess,
  //
  // ai recognize
  [A.aiRecognizeSuccess]: aiRecognizeSuccess,
  [A.fetchStopLatLonSuccess]: fetchStopLatLonSuccess,
  // calculate eta
  [A.setETAConfigList]: setETAConfigList,
  [calculateLiteCreateDOEtaSuccess]: calculateEtaSuccess,
  //
  [getBranchConfigsByNamesSuccess]: setCustomerLoadNumberByBranchConfigs,
}, getInitialState(PAGE_TYPE_CREATE_DO));
